/**
 * Parse a YouTube URL or ID and return the 11-char video id, or null.
 * Accepts youtu.be/<id>, youtube.com/watch?v=<id>, /embed/<id>, /shorts/<id>,
 * or a bare 11-char id.
 */
export function parseYouTubeId(input: string | null | undefined): string | null {
  if (!input) return null;
  const raw = input.trim();
  if (!raw) return null;
  const idRe = /^[a-zA-Z0-9_-]{11}$/;
  if (idRe.test(raw)) return raw;

  try {
    const url = new URL(raw);
    const host = url.hostname.replace(/^www\./, "");
    if (host === "youtu.be") {
      const id = url.pathname.slice(1).split("/")[0];
      return idRe.test(id) ? id : null;
    }
    if (host === "youtube.com" || host === "m.youtube.com" || host === "youtube-nocookie.com") {
      const v = url.searchParams.get("v");
      if (v && idRe.test(v)) return v;
      const parts = url.pathname.split("/").filter(Boolean);
      const marker = parts[0];
      if ((marker === "embed" || marker === "shorts" || marker === "v" || marker === "live") && parts[1]) {
        const id = parts[1];
        return idRe.test(id) ? id : null;
      }
    }
    return null;
  } catch {
    return null;
  }
}

export function youtubeThumbnail(id: string): string {
  return `https://i.ytimg.com/vi/${id}/hqdefault.jpg`;
}

export function youtubeEmbedUrl(id: string, opts?: { autoplay?: boolean }): string {
  const params = new URLSearchParams({
    rel: "0",
    modestbranding: "1",
    playsinline: "1",
  });
  if (opts?.autoplay) params.set("autoplay", "1");
  return `https://www.youtube-nocookie.com/embed/${id}?${params.toString()}`;
}